<template>
<div v-loading="!customer._id">
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-8">
          <customer-card :customer="customer"></customer-card>
        </div>
        <div class="col-md-4">
          <circle-chart-card
            :percentage="lampsPercentage"
            title=""
            :description="`Trocas Realizadas${lampsHasSeason ? ' na Temporada' : ''}: ${countLamps}/${lampsMaxProject}`"
            color="blue"
          ></circle-chart-card>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h4 class="card-title">
            <i class="ti-direction"></i> Dados do evento
          </h4>
        </div>
        <div class="card-content">
          <div class="row">
            <div
              class="col-lg-1 col-xs-12"
              style="line-height: 2.5em"
            >
              <label>Evento:</label>
            </div>

            <div
              class="col-lg-11 col-xs-12"
              style="margin-bottom: 30px;"
            >
              <select
                name="power"
                v-model="eventId"
                class="form-control"
                @change="getLampsStockOfEvent"
              >
                <option
                  value=""
                  disabled
                >
                  Selecione ...
                </option>
                <option
                  v-for="item in eventsOptions"
                  :key="item.value"
                  :value="item.value"
                >{{ item.label }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div v-if="showNewLampForm">
        <lamps-form
          @fetchData="fetchDatas"
          :customer="customer"
          :stock-lamps="currentEventStockLamps"
          :event="event"
          @on-save="fetchCustomer()"
          :lamps-left="lampsLeft"
        />
      </div>
      <div
        class="row"
        v-else-if="showAlert"
      >
        <div class="col-md-12">
          <lamps-alert :alert-text="alertText"/>
        </div>
      </div>

      <lamps-list :customer="customer"/>
    </div>
  </div>

  <div class="row">
    <div
      class="col-md-12 text-right"
      style="margin-bottom: 20px;"
    >
      <router-link :to="{name: 'customers.create'}">
        <button class="btn btn-lg btn-fill btn-info"><i class="ti-plus"></i>Novo Cliente</button>
      </router-link>

      <router-link :to="ticketsRoute">
        <a
          v-if="$can('customers.tickets')"
          class="btn btn-lg btn-fill btn-primary"
        ><i class="fa fa-ticket"></i>Gerar Ticket</a>
      </router-link>
    </div>
  </div>
</div>
</template>
<script>
import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
import CustomerCard from 'src/pages/Customers/CustomerCard'
import { mapActions, mapGetters } from 'vuex'
import LampsForm from './FormLamps'
import LampsList from './ListLamps'
import LampsAlert from './AlertLamps'

export default {
  components: { LampsAlert, LampsForm, LampsList, CustomerCard, CircleChartCard },
  data () {
    return {
      entityName: 'Lâmpadas',
      eventId: '',
      currentEventStockLamps: 0
    }
  },

  computed: {
    ...mapGetters(['eventSelected']),
    ...mapGetters('project', { config: 'project' }),
    ...mapGetters('events', { eventsOptions: 'optionsById', events: 'events' }),
    ...mapGetters('lamps', { allLamps: 'lamps', countLamps: 'countLamps' }),
    ...mapGetters('customers', { customer: 'customer' }),

    lampsHasSeason: {
      get () {
        return this.config.lamps.hasOwnProperty('hasSeason') && this.config.lamps.hasSeason
      }
    },

    lampsSeasonRange: {
      get () {
        return this.config.lamps.hasOwnProperty('seasonRange') ? this.config.lamps.seasonRange : 0
      }
    },

    lampsStartOfValidPeriod () {
      if (this.lampsHasSeason && this.lampsSeasonRange > 0) {
        return this.$moment().subtract(this.lampsSeasonRange, 'months').toISOString()
      } else if (this.lampsHasSeason && this.lampsSeasonRange === 0) {
        return (new Date()).setDate(1).setMonth(1).setHours(0).setMinute(0).setSeconds(0)
      }
    },

    eventsOptions () {
      return this.events.map((item) => {
        return {
          value: item._id,
          label: `${item.reference} - ${item.city} - ${item.place} - ${this.$moment(item.startDate)
            .format('LLL')}`
        }
      })
    },

    event: function () {
      return this.eventId ? this.events.find(item => item._id === this.eventId) : this.events[0]
    },

    showNewLampForm () {
      return this.eventId !== '' &&
        this.currentEventStockLamps > 0 &&
        this.lampsLeft > 0 &&
        this.event
    },

    lampsPercentage () {
      return this.countLamps && this.lampsMaxProject
        ? Math.floor((this.countLamps / this.lampsMaxProject) * 100) : 0
    },

    lampsLeft () {
      // console.log('COUNT LAMPS', this.countLamps, this.lampsMaxProject - this.countLamps)
      return this.lampsMaxProject - this.countLamps
    },

    lampsMaxProject () {
      return this.config.lamps.max
    },

    id () {
      return this.$route.params.id
    },

    ticketsRoute () {
      if (this.customer._id) {
        return {
          name: 'customers.tickets',
          params: { id: this.customer._id }
        }
      } else {
        return { name: 'customers.index' }
      }
    },

    showAlert () {
      return this.lampsLeft <= 0 ||
        this.eventsOptions.length <= 1 ||
        this.eventId === '' <= 0 ||
        this.currentEventStockLamps <= 0
    },

    alertText: function () {
      // console.log('COUNT LAMPS ALERT', this.lampsLeft)
      if (this.lampsLeft <= 0) {
        return 'Foi atingido o limite de lâmpadas para este cliente no projeto.'
      }
      if (this.eventsOptions.length <= 1) {
        return 'Não há eventos iniciados para que seja posśivel trocar a lâmpada.'
      } else if (this.eventId === '') {
        return 'Selecione um evento para efetuar alguma troca de lâmpadas.'
      } else if (this.currentEventStockLamps <= 0 && this.eventId !== '') {
        return 'O evento escolhido não possui mais lâmpadas em estoque.'
      }
    }
  },

  methods: {
    ...mapActions('customers', {
      fetchOne: 'fetchOne',
      resetCustomer: 'resetOne'
    }),

    ...mapActions('lamps', {
      resetLamp: 'resetOne',
      resetLamps: 'resetAll',
      fetchLampsByCustomerId: 'fetchLampsByCustomerId',
      countLampsByEvent: 'countLampsByEvent'
    }),

    ...mapActions('events', {
      resetEvents: 'resetAll',
      eventsViewAll: 'fetchViewAll',
      fetchEvents: 'fetchAll'
    }),

    ...mapActions('users', {
      fetchUsers: 'fetchAll'
    }),

    ...mapActions('project', {
      fetchProject: 'fetchOne'
    }),

    fetchCustomer () {
      this.fetchOne(this.id)
      this.fetchLampsByCustomerId(this.id)
    },

    getLampsStockOfEvent () {
      this.countLampsByEvent(this.eventId)
        .then(result => {
          let deliveryLamps = result && result.hasOwnProperty('rows') && result.rows.length > 0 ? result.rows[0].value : 0
          this.currentEventStockLamps = parseInt(this.events.find(item => item._id === this.eventId).numberOfLamps) - deliveryLamps
        })
        .catch((err) => {
          console.log(err)
        })
    },

    resetDatas () {
      this.eventId = ''
      this.resetCustomer()
      this.resetEvents()
      this.resetLamp()
      this.resetLamps()
    },

    fetchDatas () {
      if (this.eventId !== '') {
        this.getLampsStockOfEvent()
      }
      this.fetchUsers()
      this.fetchCustomer()
      this.fetchEvents({
        'where': [{ 'status': 1 }],
        'select': ['_id', 'city', 'reference', 'place', 'startDate', 'status', 'numberOfLamps', 'companyTerms', 'lamp']
      })
    }
  },

  mounted () {
    if (!this.config.hasOwnProperty('_id')) {
      this.fetchProject('config')
    }
    this.resetDatas()
    this.fetchDatas()
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/Lamps/IndexLamps.vue